<template>
  <div class="card-body">
    <div class="mb-3">
      <argon-input
        type="email"
        placeholder="Email"
        name="email"
        size="lg"
        v-model:value.sync="email"
      />
    </div>
    <div class="mb-3">
      <argon-input
        type="password"
        placeholder="Password"
        name="password"
        size="lg"
        v-model:value.sync="password"
      />
    </div>
    <argon-switch id="rememberMe">Remember me</argon-switch>

    <div class="text-center">
      <argon-button
        class="mt-4"
        variant="gradient"
        color="success"
        fullWidth
        size="lg"
        :isLoading="signInButtonClicked"
        :isLoadingText="'Sign In'"
        @click="signIn"
        >Sign in</argon-button
      >
    </div>
  </div>
</template>

<script>
import { ArgonInput, ArgonButton, ArgonSwitch } from "@/components/exporter.js";
import {
  SendPOSTUserAPI,
  SendGETUserAPI,
  SendGETServerAPI,
} from "@/customFunctions/Api.js";
import { Validator } from "@/customFunctions/Validator.js";
import { Toaster } from "@/customFunctions/Utils.js";
import { mapMutations, mapGetters } from "vuex";
import { SetStoreLoginedValues } from "@/customFunctions/Auth.js";

export default {
  name: "inputs-container",
  components: {
    ArgonInput,
    ArgonButton,
    ArgonSwitch,
  },
  data() {
    return {
      email: "",
      password: "",
      signInButtonClicked: false,
    };
  },

  computed: {
    ...mapGetters(["getAuth0PasswordPolicyEnabled"]),
  },

  methods: {
    ...mapMutations([
      "setApiKeyMutation",
      "setUserDataMutation",
      "setUserEmailMutation",
      "setUserPasswordMutation",
      "setApiRefreshTokenMutation",
      "setAccessTokenMutation",
      "setIsLoginedMutation",
    ]),

    async signIn() {
      this.signInButtonClicked = true;

      if (!this.ValidateSignIn()) {
        this.signInButtonClicked = false;
        return;
      }

      if (this.getAuth0PasswordPolicyEnabled) {
        if (!Validator.isPasswordStrong(this.password)) {
          this.signInButtonClicked = false;
          this.setUserEmailMutation(this.email);
          sessionStorage.setItem("evolvePasswordPolicyRedirect", "1");
          this.Toaster(
            "Opening the password reset page…",
            "Password security",
            "warning"
          );
          this.$router.push({ path: "/resetPassword" }).catch((err) => {
            if (err?.name !== "NavigationDuplicated") {
              console.error(err);
            }
          });
          return;
        }
      }

      const authHeader = {
        Authorization: "Basic " + btoa(this.email + ":" + this.password),
      };
      try {
        const response = await SendPOSTUserAPI("login", authHeader);
        const validateResponse = this.CheckLoginResponseStatusCode(response);
        if (!validateResponse) return;
        await this.SendGetQueries(response);
        this.FinalizeLoggining();
      } catch (e) {
        this.signInButtonClicked = false;
        console.log(e, "SignIn Exception");
      }
    },
    /** Email + non-empty password only (no min length on sign-in). */
    ValidateSignIn() {
      Validator.validateEmail(this.email);
      Validator.validatePasswordNotEmpty(this.password);
      return !Validator.validateIfHasError(this.Toaster);
    },
    async SendGetQueries(response) {
      const getProfileInfo = await SendGETUserAPI(
        "users/" + response.user.id + "/profile",
        {
          Authorization: "Bearer " + response.accessToken,
        }
      );

      const getApiRefreshToken = await SendGETServerAPI(
        "account/GetRefreshToken",
        {
          Authorization: "Bearer " + response.accessToken,
        }
      );

      this.SetValues({
        response,
        getProfileInfo,
        getApiRefreshToken,
      });
    },
    SetValues(obj) {
      this.setApiRefreshTokenMutation(obj.getApiRefreshToken.RefreshTokenApi);
      localStorage.setItem("rToken", obj.response.refreshToken);
      localStorage.setItem("user", JSON.stringify(obj.getProfileInfo));
      this.setAccessTokenMutation(obj.response.accessToken);
      this.setUserDataMutation(obj.getProfileInfo);
      SetStoreLoginedValues(this.$store, true, this.$router);
    },
    CheckLoginResponseStatusCode(response) {
      if (response.statusCode === 4) {
        this.setUserEmailMutation(this.email);
        this.setUserPasswordMutation(this.password);
        this.signInButtonClicked = false;
        window.sessionStorage.setItem("normalRedirect", true);
        this.$router.push({ name: "Change Password"});
        return false;
      }
      if (response.statusCode === 5) {
        this.signInButtonClicked = false;
        window.sessionStorage.setItem("normalRedirect", true);
        this.$router.push({ name: "Reset Password"});
        return false;
      }

      if (!response || !response.refreshToken || response.statusCode !== 0) {
        this.signInButtonClicked = false;
        this.Toaster(response.message, "Error", "danger");
        return false;
      }

      return true;
    },
    FinalizeLoggining() {
      const url = window.location.href;

      if (url.includes("redirect=")) {
        const redirectUrl = window.location.origin + "/" + url.split("redirect=")[1];

        if (window.sessionStorage.getItem("localRedirect")) {
          this.$router.push({ path: redirectUrl });
          window.sessionStorage.removeItem("localRedirect")
          return;
        }

        window.location.href = redirectUrl;
        return;
      }

      this.signInButtonClicked = false;
      this.Toaster("Welcome", "", "success");
      this.$router.push({ path: "dashboard-default" });
    },
  },
  setup() {
    return { Toaster };
  },
};
</script>
